import { Injectable } from '@angular/core';
import { UrlGeneratorService, LocaleService } from '@app/core/i18n';
import { MicrodatasContactPoints } from '@app/home/services/microdatas-contact-points';
import { microdatasSocials } from '@app/home/services/microdatas-socials';
import { EMicrodatasSlogans } from '@app/home/services/microdatas-slogans.enum';
import { EMicrodatasMercantReturnPolicy } from '@app/home/services/microdatas-mercant-return-policy.enum';

@Injectable()
export class HomeMicrodatasService {
  private region = 'WW';
  public schema_s: {};
  public schema_o: {};
  public socials = microdatasSocials;
  public contactPoints = MicrodatasContactPoints;
  public slogans = EMicrodatasSlogans;
  public mercantReturnPolicy = EMicrodatasMercantReturnPolicy;

  constructor(private urlGenerator: UrlGeneratorService, private localeService: LocaleService) {
    this.region = this.localeService.getRegionCode();
  }

  getDatas() {
    this.schema_s = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Vestiaire Collective',
      url: this.urlGenerator.generateUrl('/'),
      potentialAction: [
        {
          '@type': 'SearchAction',
          target: this.urlGenerator.generateUrl('/search?q={search_term_string}'),
          'query-input': 'required name=search_term_string'
        }
      ]
    };

    this.schema_o = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      url: this.urlGenerator.generateUrl('/'),
      logo: 'https://vestiairecollective-assets.imgix.net/logos/vestiaire-collective.png?auto=format',
      brand: 'Vestiaire Collective',
      foundingDate: '2009',
      foundingLocation: 'Paris',
      legalName: 'Vestiaire Collective',
      slogan: this.slogans[this.region],
      sameAs: this.socials[this.region],
      hasMerchantReturnPolicy: [this.mercantReturnPolicy[this.region]]
    };

    return { search: this.schema_s, organization: this.schema_o };
  }
}
